import axios from "axios";
import moment from "moment";
import { formattedJsonTOSubmit, formattedOperatorJsonTOSubmit } from 'utils/FormatHelper';
import { premisesDetails } from 'redux/reducers/premisesDetails';

export const CPP_ACCESS_DATA = "CPP_ACCESS_DATA";
export const GET_ADDRESS = "GET_ADDRESS";
export const CURRENT_FORM = "CURRENT_FORM";
export const CLEANUP_ADDRESS = "CLEANUP_ADDRESS";
export const MAKE_CPP_PAYMENT = "MAKE_CPP_PAYMENT";
export const GET_APPLICATION_FULFILLED = "GET_APPLICATION_FULFILLED";
export const GET_PROCESS_2FA = "GET_PROCESS_2FA";
export const GET_SERVICE_COMPLETION_REFERENCE = "GET_SERVICE_COMPLETION_REFERENCE";
export const GET_SERVICE_REFERENCE = "GET_SERVICE_REFERENCE";
export const STORE_PERSONAL_DETAILS = "STORE_PERSONAL_DETAILS";
export const STORE_TATTOOIST_DETAILS = "STORE_TATTOOIST_DETAILS";
export const STORE_DISCLOSURES = "STORE_DISCLOSURES";
export const STORE_HISTORY = "STORE_HISTORY";
export const SUBMIT_APPLICATION_DATA = "SUBMIT_APPLICATION_DATA";
export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const SAVE_APPLICATION = "SAVE_APPLICATION";
export const GET_APPLICATION = "GET_APPLICATION";
export const CALCULATE_FEES = "CALCULATE_FEES";
export const INIT_PAYMENT = "INIT_PAYMENT";
export const STORE_APPLICATION_PAYMENT = "STORE_APPLICATION_PAYMENT";
export const STORE_EMPLOYMENT_DETAILS = "STORE_EMPLOYMENT_DETAILS";
export const STORE_APPLICANT_DETAILS = "STORE_APPLICANT_DETAILS";
export const STORE_DOCUMENTS = "STORE_DOCUMENTS";
export const STORE_UPLOAD_STATUS = "STORE_UPLOAD_STATUS";
export const STORE_COLLECTION_OF_LICENCE = "STORE_COLLECTION_OF_LICENCE";
export const CAPTCHA_VALID = "CAPTCHA_VALID";
export const CLEAR_FORM = "CLEAR_FORM";
export const STORE_PAYMENT_REFERENCE = "STORE_PAYMENT_REFERENCE";
export const STORE_REDIRECT = "STORE_REDIRECT";
export const REDIRECT_TRIGGER = "REDIRECT_TRIGGER";
export const GET_PAYMENT_PDF_LINK = "GET_PAYMENT_PDF_LINK";
export const CLEAN_PDF = "CLEAN_PDF";
export const SEND_EMAIL_COPY = "SEND_EMAIL_COPY";
export const CLEAN_SEND_EMAIL = "CLEAN_SEND_EMAIL";
export const GET_SERVICE_CENTRES = "GET_SERVICE_CENTRES";

export const STORE_OWNERSHIP_DETAILS = "STORE_OWNERSHIP_DETAILS";
export const STORE_OWNERSHIP_DETAILS_CORPORATION = "STORE_OWNERSHIP_DETAILS_CORPORATION";
export const STORE_OWNERSHIP_DETAILS_PARTNER = "STORE_OWNERSHIP_DETAILS_PARTNER";
export const STORE_OWNERSHIP_DETAILS_TRUST = "STORE_OWNERSHIP_DETAILS_TRUST";

export const STORE_CLOSE_ASSOCIATES_DETAILS = "STORE_CLOSE_ASSOCIATES_DETAILS";
export const STORE_CLOSE_ASSOCIATES_CORPORATIONS = "STORE_CLOSE_ASSOCIATES_CORPORATIONS";
export const STORE_CLOSE_ASSOCIATES_INDIVIDUALS = "STORE_CLOSE_ASSOCIATES_INDIVIDUALS";
export const STORE_CLOSE_ASSOCIATES_EMPLOYEES = "STORE_CLOSE_ASSOCIATES_EMPLOYEES";
export const STORE_PREMISES_DETAILS = "STORE_PREMISES_DETAILS";
export const STORE_OPERATOR_DISCLOSURES = "STORE_OPERATOR_DISCLOSURES";
export const STORE_RESIDENCY_DETAILS = "STORE_RESIDENCY_DETAILS";

export const cleanPdf = () => ({
  type: CLEAN_PDF,
  payload: {},
});

export const cleanSendEmail = () => ({
  type: CLEAN_SEND_EMAIL,
  payload: {},
});

export const storeCaptcha = data => ({
  type: CAPTCHA_VALID,
  payload: { ...data }
});

export const clearForm = () => ({
  type: CLEAR_FORM,
  payload: {},
});

export const storePaymentRefrence = (data) => ({
  type: STORE_PAYMENT_REFERENCE,
  payload: { ...data }
});

export const setCurrentForm = (currentForm, licenceName) => ({
  type: CURRENT_FORM,
  payload: { currentForm, licenceName }
});

export const getAddress = addressString => ({
  type: GET_ADDRESS,
  payload: {
    promise: axios
      .get(
        `${process.env.REACT_APP_BASE_URL}${process.env
          .REACT_APP_GET_ADDRESS_URL}?q=${addressString}`
      )
      .then(response => response)
  }
});

export const cleanupAddresses = () => ({
  type: CLEANUP_ADDRESS,
  payload: {}
});
//old sample - delete
export const storePersonalDetails = data => ({
  type: STORE_PERSONAL_DETAILS,
  payload: { ...data }
});

export const storeOwnershipDetails = data => ({
  type: STORE_OWNERSHIP_DETAILS,
  payload: { ...data }
});

export const storeOwnershipDetailsCorporation = data => ({
  type: STORE_OWNERSHIP_DETAILS_CORPORATION,
  payload: { ...data }
});

export const storeOwnershipDetailsPartner = data => ({
  type: STORE_OWNERSHIP_DETAILS_PARTNER,
  payload: { ...data }
});

export const storeOwnershipDetailsTrust = data => ({
  type: STORE_OWNERSHIP_DETAILS_TRUST,
  payload: { ...data }
});

export const storeCloseAssociatesDetails = data => ({
  type: STORE_CLOSE_ASSOCIATES_DETAILS,
  payload: { ...data }
});

export const storeCloseAssociateCorporations = data => ({
  type: STORE_CLOSE_ASSOCIATES_CORPORATIONS,
  payload: { ...data }
});

export const storeCloseAssociateIndividuals = data => ({
  type: STORE_CLOSE_ASSOCIATES_INDIVIDUALS,
  payload: { ...data }
});

export const storeCloseAssociateEmployees = data => ({
  type: STORE_CLOSE_ASSOCIATES_EMPLOYEES,
  payload: { ...data }
});

export const storePremisesDetails = data => ({
  type: STORE_PREMISES_DETAILS,
  payload: { ...data }
});

export const storeOperatorDisclosures = data => ({
  type: STORE_OPERATOR_DISCLOSURES,
  payload: { ...data }
});

export const storeProofOfResidency = data => ({
  type: STORE_RESIDENCY_DETAILS,
  payload: { ...data }
});

export const storeTattooistDetails = data => ({
  type: STORE_TATTOOIST_DETAILS,
  payload: { ...data }
});
export const storeApplicantDetails = data => ({
  type: STORE_APPLICANT_DETAILS,
  payload: { ...data }
});
export const storeEmploymentDetails = data => ({
  type: STORE_EMPLOYMENT_DETAILS,
  payload: { ...data }
});
export const storeCollectionOfLicence = data => ({
  type: STORE_COLLECTION_OF_LICENCE,
  payload: { ...data }
});
export const storeDocuments = data => ({
  type: STORE_DOCUMENTS,
  payload: { ...data }
});
export const storeUploadStatus = data => ({
  type: STORE_UPLOAD_STATUS,
  payload: { ...data }
});
export const storeDisclosures = data => ({
  type: STORE_DISCLOSURES,
  payload: { ...data }
});

export const storeRedirect = (url) => ({
  type: STORE_REDIRECT,
  payload: { url },
});


export const redirectTrigger = (trigger, callback) => ({
  type: REDIRECT_TRIGGER,
  meta: { trigger },
  payload: {
    promise: new Promise((resolve) => {
      resolve();
    }).then(r => {
      if (callback) {
        callback();
        return r;
      } else {
        return r;
      }
    })
  }
});

export const process2FA = (callBack) => (
  dispatch,
  getState
) => {
  const {
    oidc
  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};


  dispatch({
    type: GET_PROCESS_2FA,
    payload: {
      promise: axios.post(
        `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/twofa/connect`,
        {
          ...data
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
        .then(response => {
          callBack(response.data);
        })
    }
  });
};

export const getServiceCompletionReference = (serviceCompletionReferenceID) => (
  dispatch,
  getState
) => {
  const {
    oidc,
    application
  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};
  const applicationId = application.applicationId;

  dispatch({
    type: GET_SERVICE_COMPLETION_REFERENCE,
    payload: {
      promise: axios.get(
        `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/twofa/servicecompletionreference/${serviceCompletionReferenceID}?applicationId=${applicationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
        .then(response => {
          return response;
        })
    }
  });
};

export const downloadPaymentPDF = (applicationNo, applicationId, formType) => (dispatch, getState) => {
  const { oidc } = getState();
  const token = oidc.user && oidc.user.access_token;
  let data = {};
  let fileName = '';
  let form = '';
  if (formType === 'operator') {
    fileName = `${applicationNo}_Operator_Application`;
    form = 'operator';
  } else {
    fileName = `${applicationNo}_Tattooist_Application`;
    form = 'tattooist';
  }


  dispatch({
    type: GET_PAYMENT_PDF_LINK,
    meta: { fileName },
    payload: {
      promise: axios
        .post(`${process.env.REACT_APP_BASE_URL}/tattooapi/V1/${form}/generatepdf/${applicationId}`,
          data, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
        )
    }
  })
};

export const getServiceReference = (serviceReferenceID) => (
  dispatch,
  getState
) => {
  const {
    oidc,
    application
  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};

  const applicationId = application.applicationId;

  dispatch({
    type: GET_SERVICE_REFERENCE,
    payload: {
      promise: axios.get(
        `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/twofa/servicereference/${serviceReferenceID}/${applicationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
        .then(response => {
          return response;
        })
    }
  });
};

export const getServiceCentres = () => (
  dispatch,
  getState
) => {
  const {
    oidc
  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};

  dispatch({
    type: GET_SERVICE_CENTRES,
    payload: {
      promise: axios.get(
        `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/tattooist/servicecentres`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
        .then(response => {
          return response;
        })
    }
  });
};

export const createApplication = (form, callBack) => (dispatch, getState) => {
  const {
    oidc,

  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};

  data.licenceType = form === 'operator' ? 'Operator Licence' : "Tattooist Licence";
  data.applicationData = JSON.stringify(getState());

  dispatch({
    type: CREATE_APPLICATION,
    payload: {
      promise: axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/applications`,
          {
            ...data
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          callBack();
          return response;
        })
    }
  });
};

export const saveApplication = (stepNumber, callBack) => (dispatch, getState) => {
  const {
    oidc,

  } = getState();
  const token = oidc.user && oidc.user.access_token;
  let { application, applicantDetails, collectionOfLicence, disclosures, documents, form,
    employment, tattooistDetails, twoFA, closeAssociateDetails, ownershipDetails, premisesDetails } = getState();

  const JsonData = {
    application,
    applicantDetails,
    collectionOfLicence,
    form,
    closeAssociateDetails,
    ownershipDetails,
    premisesDetails,
    disclosures,
    documents,
    employment,
    tattooistDetails,
    twoFA,
    stepNumber: stepNumber
  };

  const data = {};

  data.applicationId = application.applicationId;
  data.applicationData = JSON.stringify(JsonData);//as per server api format, we need to stringify

  dispatch({
    type: SAVE_APPLICATION,
    payload: {
      promise: axios
        .put(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/applications`,
          {
            ...data
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          callBack();
          return response;
        })
    }
  });
};

export const getApplication = (applicationId, callBack) => (
  dispatch,
  getState
) => {
  const {
    oidc
  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};


  dispatch({
    type: GET_APPLICATION,
    payload: {
      promise: axios.get(
        `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/applications/${applicationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
        .then(function (response) {
          callBack(response);
          return {
            applicationNo: response.data.applicationNo,
            licenceType: response.data.licenceType,
            ...JSON.parse(response.data.applicationData)
          };
        })
    }
  });
};

export const submitApplicationData = () => (dispatch, getState) => {
  const {
    application,
    training,
    personalDetails,
    identityProof,
    history,
    mentalCapacity,
    oidc,
    form,
    intlIdentityProof,
    competitionDetails
  } = getState();
  const token = oidc.user && oidc.user.access_token;

  const data = {};
  if (form.form === "new-international-competitor") {
    data.application = application;
    data.personalDetails = personalDetails;
    data.intlIdentityProof = intlIdentityProof;
    data.history = history;
    data.mentalCapacity = mentalCapacity;
    data.competitionDetails = competitionDetails;
  } else {
    data.application = application;
    data.training = training;
    data.personalDetails = personalDetails;
    data.identityProof = [
      identityProof.firstDocument,
      identityProof.secondDocument
    ];
    data.history = history;
    data.mentalCapacity = mentalCapacity;
  }

  dispatch({
    type: SUBMIT_APPLICATION_DATA,
    payload: {
      promise: axios
        .patch(
          `${process.env.REACT_APP_BASE_URL}/api/${application.applicationID}`,
          {
            form: {
              ...data
            }
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          dispatch(getTokenAndMakeCppPayment(75, form.licenceName));
          return response;
        })
    }
  });
};

export const calculateFees = () => (dispatch, getState) => {
  const {
    oidc, application, applicantDetails, collectionOfLicence, disclosures, documents, employment, tattooistDetails, twoFA
  } = getState();

  const token = oidc.user && oidc.user.access_token;

  const data = formattedJsonTOSubmit(application, applicantDetails, collectionOfLicence, disclosures, documents, employment, tattooistDetails, twoFA);

  dispatch({
    type: CALCULATE_FEES,
    payload: {
      promise: axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/tattooist/fees`,
          {
            ...data
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          return response;
        })
    }
  });
};

export const sendEmailCopy = (email, applicationId) => (dispatch, getState) => {
  const { oidc, form } = getState();
  const token = oidc.user && oidc.user.access_token;
  const data = {};

  data.applicationId = applicationId;
  data.emailAddress = email;

  var apiUrl = sessionStorage["form"] === 'operator' ? 'operator' : 'tattooist';

  dispatch({
    type: SEND_EMAIL_COPY,
    payload: {
      promise: axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/${apiUrl}/sendemail`,
          {
            ...data,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(response => {
          return response;
        }),
    },
  });
};

export const calculateOperatorFees = () => (dispatch, getState) => {
  const {
    oidc, application, applicantDetails, ownershipDetails, closeAssociateDetails, premisesDetails,
    collectionOfLicence, disclosures, documents, tattooistDetails, twoFA
  } = getState();

  const token = oidc.user && oidc.user.access_token;

  const data = formattedOperatorJsonTOSubmit(application, applicantDetails, ownershipDetails, closeAssociateDetails, premisesDetails,
    collectionOfLicence, disclosures, documents, tattooistDetails, twoFA);

  console.log('operator json:', data);
  dispatch({
    type: CALCULATE_FEES,
    payload: {
      promise: axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/operator/fees`,
          {
            ...data
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          return response;
        })
    }
  });
};

export const initPayment = () => (dispatch, getState) => {
  const {
    oidc, application, applicantDetails, collectionOfLicence, disclosures, documents, employment, tattooistDetails, twoFA
  } = getState();

  const token = oidc.user && oidc.user.access_token;

  const data = formattedJsonTOSubmit(application, applicantDetails, collectionOfLicence, disclosures, documents, employment, tattooistDetails, twoFA);

  dispatch({
    type: INIT_PAYMENT,
    payload: {
      promise: axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/tattooist/initpayment`,
          {
            formattedApplication: { ...data }
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          console.log('sapan got payment link ', response);
          return response;
        })
    }
  });
};

export const initOperatorPayment = () => (dispatch, getState) => {
  const {
    oidc, application, applicantDetails, ownershipDetails, closeAssociateDetails, premisesDetails,
    collectionOfLicence, disclosures, documents, tattooistDetails, twoFA
  } = getState();

  const token = oidc.user && oidc.user.access_token;

  const data = formattedOperatorJsonTOSubmit(application, applicantDetails, ownershipDetails, closeAssociateDetails, premisesDetails,
    collectionOfLicence, disclosures, documents, tattooistDetails, twoFA);

  dispatch({
    type: INIT_PAYMENT,
    payload: {
      promise: axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/tattooapi/V1/operator/initpayment`,
          {
            formattedApplication: { ...data }
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        .then(response => {
          return response;
        })
    }
  });
};

export const getTokenAndMakeCppPayment = (amount, licenceName) => (
  dispatch,
  getState
) => {
  const { cpp } = getState();
  const { accessToken, expires, tokenRetrieved } = cpp;
  const now = moment();
  const tokenExpires = moment(expires);
  if (!tokenRetrieved || !accessToken || now.isAfter(tokenExpires)) {
    dispatch({
      type: CPP_ACCESS_DATA,
      payload: {
        promise: axios
          .post(`${process.env.REACT_APP_BASE_URL}/apigee/token`)
          .then(response => {
            if (
              response &&
              response.data &&
              response.status === 200 &&
              response.data.access_token
            ) {
              dispatch(
                makeCppPayment(amount, licenceName, response.data.access_token)
              );
            }
            return response;
          })
      }
    });
  } else {
    dispatch(makeCppPayment(amount, licenceName, accessToken));
  }
};

export const makeCppPayment = (amount, licenceName, accessToken) => (
  dispatch,
  getState
) => {
  const { application } = getState();
  const { applicationID, applicationNo } = application;
  const cppUrl = `${process.env.REACT_APP_BASE_URL}/cppapi/request-payment`;
  dispatch({
    type: MAKE_CPP_PAYMENT,
    payload: {
      promise: axios
        .post(
          cppUrl,
          {
            agencyCode: "fairtradingnsw",
            productDescription: licenceName,
            amount,
            agencyTransactionId: applicationID,
            callingSystem: "webportalsit",
            referenceNumber: applicationNo
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log("response", response);
          return response;
        })
    }
  });
};
